import { ICreateSessionUseCase } from '../../interfaces/use-cases/ICreateSessionUseCase';
import { ISessionManager, SessionSetupFunction } from '../../interfaces/core/ISessionManager';
import { TestSessionOptions } from '../../interfaces/core/ITestSession';

export class CreateSessionUseCase implements ICreateSessionUseCase {
  constructor(private sessionManager: ISessionManager) {}

  async execute(
    label: string,
    setupFn: SessionSetupFunction,
    options?: Partial<TestSessionOptions>
  ): Promise<string> {
    const session = await this.sessionManager.createSession(label, setupFn, options);
    return session.label;
  }
}
